var object = {
  methods: {},
  computed: {},
  watch: {},
  name: 'public_heade',
  data() {
    return {
      rs_: {},
      show_: {},
      nors_: {},
      parem_: {}
    };
  },
  // 注册子组件
  components: {},
  // 动态更新页面，完成时触发
  updated() {}
};
export default object;